<div class="px-4 py-5 sm:px-6">
  <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
    <ng-content></ng-content>
  </dl>
</div>
